import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function TitleSection() {
    console.log(useLocation().state)
    let title = useLocation().state.title
    return (
        <Row className='product-title-section mx-0'>
            <Col md={6} className='product-page-title h-100 d-flex align-items-center'>
                <h3 className='w-100' style={{ fontWeight: '800', fontSize: '2em', textAlign:'start' }}>{title}</h3>
            </Col>
            <Col md={6} className='w-100'></Col>
        </Row>
    )
}
